<script>
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'customerQuoteItem',
    props: {
        quote: Object,
    },
    setup() {},
    methods: {
        onBeforeShow(evt) {
            console.log(evt);
        },
        onHide(evt) {
            console.log(evt)
        },
        calculateSubTotal(uom, qty, price) {

            if (uom == "MFT" || uom == "FT") {
                return new Intl.NumberFormat("en-EN", {minimumFractionDigits: 2, maximumFractionDigits: 2}).format((parseInt(qty)/1000) * parseFloat(price))
            } 
            return new Intl.NumberFormat("en-EN", {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(parseInt(qty) * parseFloat(price))

        }
    }
})
</script>

<template>
    <q-expansion-item expand-icon-class="wcwBlue expandIconWCW">
        <template v-slot:header>
            <q-item-section>
            <div class="row">
                <div class="col-12">
                <h2 style="line-height: 1.5em;">#{{quote.quoteNumber}}</h2>
                <span class="orderPrice">${{quote.quoteAmount}}</span>
                </div>
            </div>
            </q-item-section>
            <q-item-section side>
                <div class="row items-center">
                    <span class="q-pt-xs q-pl-sm text-cyan-7">{{quote.description}}</span>
                </div>
            </q-item-section>
        </template>

        <template v-slot:default>
            <div class="bodyContainer consignmentProduct">
				<div class="quoteInformation">
					<span class="quotesDescription">Description:<span>{{quote.description}}</span></span>
					<span class="goodThroughDate">Good Through Date:<span>{{quote.goodThroughDate}}</span></span>
				</div>
                <div class="orderView" v-for="(item, idx) in quote.items" :key=idx>
                    <div class="row">
                        <div class="col-6">
                            <strong>{{item.itemNumber}}</strong>
                            <p class="orderProductDescription">{{item.description}}</p>
                        </div>
                        <div class="col-6">
                            <span v-if="item.quantityOrdered" class="orderQuantity">Quantity: <span class="ml-1">{{parseInt(item.quantityOrdered)}}</span></span>
                            <span v-if="item.quantityShipped" class="orderQuantity">Quantity: <span class="ml-1">{{parseInt(item.quantityShipped)}}</span></span>
                            <span class="orderProductPrice">${{item.priceExtension}} {{item.priceUnitOfMeasure}}</span>
                            <span v-if="item.quantityOrdered" class="orderSubTotal">Subtotal: <span>${{calculateSubTotal(item.quantityUnitOfMeasure, item.quantityOrdered, item.priceExtension)}}</span></span>
                            <span v-if="item.quantityShipped" class="orderSubTotal">Subtotal: <span>${{calculateSubTotal(item.quantityUnitOfMeasure, item.quantityShipped, item.priceExtension)}}</span></span>
                        </div>
                    </div>	
                </div>
                <div class="orderInformationBottom q-mt-sm">
                    <div class="row">
                        <div class="col-6 text-center">
                            <q-btn color="cyan-7" :unelevated=true icon="fas fa-cart-plus" label="Order" size="md" @click="$store.commit('customer/setQuoteToOrder', quote)"/>
                        </div>
                        <div class="col-6 text-center">
                            <q-btn color="cyan-7" :unelevated=true icon="fas fa-envelope" label="Email" size="md" style="width: 135px" @click="$store.commit('customer/setEmailQuote', quote)"/>
                        </div>
                    </div>
                </div>
            </div>
        </template>


    </q-expansion-item>
    <div class="mobileDiv"></div>
      
</template>

<style>
.expandIconWCW i{font-size: 45px !important; padding-right: 0px;}
</style>